import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {  getToolBrandList } from "../../Thunks/HeyTraderThunks";
import { ToolType } from "../../Types/HeyTraderTypes/Tools/ToolType";

interface ToolBrandSliceState {
    loader: boolean; // for refres pages and inital loadings
    toolBrands: ToolType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolBrandSliceState = {
    loader: false,
    toolBrands: [],
    errorDisplay: '',

}

// set state valu for api response

const toolBrandslice = createSlice ({
    name: 'toolBrands',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getToolBrandList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getToolBrandList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getToolBrandList.fulfilled, (state, action: PayloadAction<ToolType[]>) => {
                    state.loader = false;
                    state.toolBrands = action.payload;
                  })
    }
})

export const {} = toolBrandslice.actions
export default toolBrandslice.reducer

